import React, { useState } from 'react';
import { PlusIcon, TrashIcon, CalendarIcon, InfoIcon, TruckIcon, CircleDollarSignIcon } from 'lucide-react';
export function ShippingTermsStep({
  initialData,
  onUpdate
}) {
  const [formData, setFormData] = useState({
    currency: initialData.currency || 'USD',
    incoterm: initialData.incoterm || 'FOB',
    paymentTerms: initialData.paymentTerms || '30/70',
    quoteValidUntil: initialData.quoteValidUntil || '',
    desiredDeliveryDate: initialData.desiredDeliveryDate || '',
    notes: initialData.notes || '',
    shipments: initialData.shipments || [{
      origin: 'Spain',
      destination: '',
      method: 'Ocean',
      containerType: '40ft HC',
      totalPrice: 0,
      transitTime: ''
    }],
    ...initialData
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    onUpdate({
      ...formData,
      [name]: value
    });
  };
  const handleAddShipment = () => {
    const newShipments = [...formData.shipments, {
      origin: 'Spain',
      destination: '',
      method: 'Ocean',
      containerType: '40ft HC',
      totalPrice: 0,
      transitTime: ''
    }];
    setFormData({
      ...formData,
      shipments: newShipments
    });
    onUpdate({
      ...formData,
      shipments: newShipments
    });
  };
  const handleRemoveShipment = index => {
    const newShipments = formData.shipments.filter((_, i) => i !== index);
    setFormData({
      ...formData,
      shipments: newShipments
    });
    onUpdate({
      ...formData,
      shipments: newShipments
    });
  };
  const handleShipmentChange = (index, field, value) => {
    const newShipments = [...formData.shipments];
    newShipments[index][field] = value;
    setFormData({
      ...formData,
      shipments: newShipments
    });
    onUpdate({
      ...formData,
      shipments: newShipments
    });
  };
  return <div className="space-y-8" data-id="element-5127" data-mp="2wnawnet6rhn2">
      <div className="text-white text-xl font-medium mb-6" data-id="element-5128" data-mp="zl3n6nr9genq">
        Shipping & Payment Terms
      </div>
      {/* Financial Terms */}
      <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-5129" data-mp="14jdlh78a7vdk">
        <div className="flex items-center mb-4" data-id="element-5130" data-mp="19iqgwgd7yarr">
          <CircleDollarSignIcon size={20} className="text-blue-400 mr-2" data-id="element-5131" data-mp="19hyiyyw5g0yb" />
          <h3 className="text-white font-medium" data-id="element-5132" data-mp="1eje8p499uvn1">Financial Terms</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-5133" data-mp="1ikpyb9s5bgv8">
          <div data-id="element-5134" data-mp="1ii3p75plwtaw">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-5135" data-mp="1nirixz57zo8t">Currency</label>
            <select name="currency" value={formData.currency} onChange={handleChange} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 10px center',
            backgroundSize: '20px'
          }} data-id="element-5136" data-mp="1ngohmiyma8os">
              <option value="USD" data-id="element-5137" data-mp="3crs6p2rbhd45">USD ($)</option>
              <option value="EUR" data-id="element-5138" data-mp="3ct3gpkbcvh3p">EUR (€)</option>
              <option value="GBP" data-id="element-5139" data-mp="ea6angqhh1tu">GBP (£)</option>
              <option value="AUD" data-id="element-5140" data-mp="e9mv26ob2piz">AUD (A$)</option>
              <option value="CAD" data-id="element-5141" data-mp="9bblzy5u4j1t">CAD (C$)</option>
            </select>
          </div>
          <div data-id="element-5142" data-mp="9dfpieztng1k">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-5143" data-mp="4k3cl24i8xon">Incoterm</label>
            <select name="incoterm" value={formData.incoterm} onChange={handleChange} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 10px center',
            backgroundSize: '20px'
          }} data-id="element-5144" data-mp="4i0edut77y8u">
              <option value="EXW" data-id="element-5145" data-mp="vifibj8yebpp">EXW (Ex Works)</option>
              <option value="FCA" data-id="element-5146" data-mp="vixjmuah3g4h">FCA (Free Carrier)</option>
              <option value="FOB" data-id="element-5147" data-mp="10i0gvsk7oi1w">FOB (Free On Board)</option>
              <option value="CFR" data-id="element-5148" data-mp="10jbiblq6pdpu">CFR (Cost and Freight)</option>
              <option value="CIF" data-id="element-5149" data-mp="lrt2bnxbrj6h">CIF (Cost, Insurance & Freight)</option>
              <option value="DAP" data-id="element-5150" data-mp="qqxemnfjpx11">DAP (Delivered At Place)</option>
              <option value="DDP" data-id="element-5151" data-mp="1eh9uqlky302p">DDP (Delivered Duty Paid)</option>
            </select>
          </div>
          <div data-id="element-5152" data-mp="1j8003ytdf2xe">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-5153" data-mp="1j8i4jiq6snge">
              Payment Terms
            </label>
            <select name="paymentTerms" value={formData.paymentTerms} onChange={handleChange} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 10px center',
            backgroundSize: '20px'
          }} data-id="element-5154" data-mp="33xlumsge8dcp">
              <option value="100" data-id="element-5155" data-mp="2p0d2hwj9n5jx">100% Payment in Advance</option>
              <option value="30/70" data-id="element-5156" data-mp="99h0d9q0z6qc">30% Advance, 70% Before Shipment</option>
              <option value="50/50" data-id="element-5157" data-mp="4axef9bfluxz">50% Advance, 50% Before Shipment</option>
              <option value="20/80" data-id="element-5158" data-mp="4aniz67mavkw">20% Advance, 80% Before Shipment</option>
              <option value="LC" data-id="element-5159" data-mp="2y23s6c7javqk">Letter of Credit</option>
              <option value="NET30" data-id="element-5160" data-mp="331q5smr9ydzw">Net 30 Days</option>
            </select>
          </div>
        </div>
      </div>
      {/* Dates */}
      <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-5161" data-mp="374v7in3j6bnh">
        <div className="flex items-center mb-4" data-id="element-5162" data-mp="3c2wqz94vcczh">
          <CalendarIcon size={20} className="text-blue-400 mr-2" data-id="element-5163" data-mp="3c0k7grjgpukb" />
          <h3 className="text-white font-medium" data-id="element-5164" data-mp="2fdp0dmpe7dop">Important Dates</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5165" data-mp="2jd7p6tkc48wt">
          <div data-id="element-5166" data-mp="2od2cyo8tcidn">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-5167" data-mp="2ock8j4bzyxun">
              Quote Valid Until
            </label>
            <div className="relative" data-id="element-5168" data-mp="2t42d02d8bgkd">
              <input type="date" name="quoteValidUntil" value={formData.quoteValidUntil} onChange={handleChange} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-5169" data-mp="2t5vi3d871sq9" />
              <CalendarIcon size={18} className="absolute right-3 top-3 text-blue-400 pointer-events-none" data-id="element-5170" data-mp="1t2xew6r5e4lk" />
            </div>
          </div>
          <div data-id="element-5171" data-mp="1o2swgb6oizsp">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-5172" data-mp="1j5srk3lkg336">
              Desired Delivery Date
            </label>
            <div className="relative" data-id="element-5173" data-mp="1f4qrjkjtrn05">
              <input type="date" name="desiredDeliveryDate" value={formData.desiredDeliveryDate} onChange={handleChange} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-5174" data-mp="1f3nxj3r7h4g0" />
              <CalendarIcon size={18} className="absolute right-3 top-3 text-blue-400 pointer-events-none" data-id="element-5175" data-mp="10ejjlyrg1mdp" />
            </div>
          </div>
        </div>
      </div>
      {/* Shipments */}
      <div data-id="element-5176" data-mp="rf4qerjw6xpi">
        <div className="flex items-center justify-between mb-4" data-id="element-5177" data-mp="rdla50y8kmnq">
          <div className="flex items-center" data-id="element-5178" data-mp="mfjvcs7uf9i2">
            <TruckIcon size={20} className="text-blue-400 mr-2" data-id="element-5179" data-mp="mguuufu99v3d" />
            <h3 className="text-white font-medium" data-id="element-5180" data-mp="2abq0zg027kqp">Shipment Details</h3>
          </div>
          <button onClick={handleAddShipment} className="text-sm flex items-center text-blue-400 hover:text-blue-300" data-id="element-5181" data-mp="2fb2lvv7dehqn">
            <PlusIcon size={16} className="mr-1" data-id="element-5182" data-mp="21cbbairpve79" />
            Add Shipment
          </button>
        </div>
        {formData.shipments.map((shipment, index) => <div key={index} className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30 mb-4 relative" data-id="element-5183" data-mp="25f7wmh8n5oew" data-mpi={index}>
            {formData.shipments.length > 1 && <button onClick={() => handleRemoveShipment(index)} className="absolute top-4 right-4 p-1.5 rounded-full bg-red-500/20 text-red-400 hover:bg-red-500/40 hover:text-white transition-colors" data-id="element-5184" data-mp="1wcqae2szkvrw">
                <TrashIcon size={16} data-id="element-5185" data-mp="1mlvqv674kaa5" />
              </button>}
            <h4 className="text-white font-medium mb-4" data-id="element-5186" data-mp="1mkawbgkt8rca">
              Shipment {index + 1}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-5187" data-mp="1dlz2z6sk7fg5">
              <div data-id="element-5188" data-mp="1do1slppsv6kc">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-5189" data-mp="u05p7zwj0eck">
                  Origin
                </label>
                <input type="text" value={shipment.origin} onChange={e => handleShipmentChange(index, 'origin', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Country of origin" data-id="element-5190" data-mp="p1lyznawggee" />
              </div>
              <div data-id="element-5191" data-mp="1cxqcj2jn74v2">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-5192" data-mp="1cx6xbtldmukq">
                  Destination
                </label>
                <input type="text" value={shipment.destination} onChange={e => handleShipmentChange(index, 'destination', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Country of destination" data-id="element-5193" data-mp="1mouso5l20vrh" />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-5194" data-mp="1qs0v1251q2so">
              <div data-id="element-5195" data-mp="358brxo9gbyz0">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-5196" data-mp="358va9630kpdk">
                  Shipping Method
                </label>
                <select value={shipment.method} onChange={e => handleShipmentChange(index, 'method', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '20px'
            }} data-id="element-5197" data-mp="30fa9j6a1dhao">
                  <option value="Ocean" data-id="element-5198" data-mp="1xu8o2zzbsagu">Ocean Freight</option>
                  <option value="Air" data-id="element-5199" data-mp="1xwutou2nofwf">Air Freight</option>
                  <option value="Road" data-id="element-5200" data-mp="ddsexqnkcs4g">Road Transport</option>
                  <option value="Rail" data-id="element-5201" data-mp="ib11s4jnpkc1">Rail Transport</option>
                  <option value="Multimodal" data-id="element-5202" data-mp="i9hl4cu3979q">Multimodal</option>
                </select>
              </div>
              <div data-id="element-5203" data-mp="n8u60s1eg49o">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-5204" data-mp="s13t80b4qq89">
                  Container Type
                </label>
                <select value={shipment.containerType} onChange={e => handleShipmentChange(index, 'containerType', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '20px'
            }} data-id="element-5205" data-mp="wzf1w7pouuow">
                  <option value="20ft" data-id="element-5206" data-mp="3ep2yvszr5rv8">20ft Standard</option>
                  <option value="40ft" data-id="element-5207" data-mp="3eqnpx8muysoc">40ft Standard</option>
                  <option value="40ft HC" data-id="element-5208" data-mp="39pqcf9csmmt6">40ft High Cube</option>
                  <option value="LCL" data-id="element-5209" data-mp="39scif4k1cu9a">LCL (Less than Container Load)</option>
                  <option value="Bulk" data-id="element-5210" data-mp="3nny6n9ig3a0n">Bulk Cargo</option>
                  <option value="Pallet" data-id="element-5211" data-mp="3joz1powprd97">Palletized</option>
                </select>
              </div>
              <div data-id="element-5212" data-mp="1ag5nnxyktf2">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-5213" data-mp="19oi90eim1zv">
                  Shipping Price
                </label>
                <div className="relative" data-id="element-5214" data-mp="3sikg374yusi3">
                  <span className="absolute left-4 top-2.5 text-gray-400" data-id="element-5215" data-mp="b7ks7ovpuqwe">
                    {formData.currency === 'USD' ? '$' : formData.currency === 'EUR' ? '€' : formData.currency === 'GBP' ? '£' : formData.currency === 'AUD' ? 'A$' : 'C$'}
                  </span>
                  <input type="number" value={shipment.totalPrice} onChange={e => handleShipmentChange(index, 'totalPrice', parseFloat(e.target.value))} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg pl-8 pr-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" min="0" step="100" data-id="element-5216" data-mp="two5vxiozfnq" />
                </div>
              </div>
            </div>
            <div className="mt-4" data-id="element-5217" data-mp="64zd6g1ykp69">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-5218" data-mp="aybzukn2ulwd">
                Estimated Transit Time
              </label>
              <input type="text" value={shipment.transitTime} onChange={e => handleShipmentChange(index, 'transitTime', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="E.g. 4-6 weeks" data-id="element-5219" data-mp="3td2xhhci8ome" />
            </div>
          </div>)}
      </div>
      {/* Additional Notes */}
      <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-5220" data-mp="vh6q6w97ulc2">
        <div className="flex items-center mb-4" data-id="element-5221" data-mp="qilqqz1sg5oo">
          <InfoIcon size={20} className="text-blue-400 mr-2" data-id="element-5222" data-mp="qjwzzee065n6" />
          <h3 className="text-white font-medium" data-id="element-5223" data-mp="lrde7u55w47a">Additional Notes</h3>
        </div>
        <div data-id="element-5224" data-mp="gtu1wzs0y1hz">
          <textarea name="notes" value={formData.notes} onChange={handleChange} rows={4} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter any additional notes, special requirements or terms..." data-id="element-5225" data-mp="gsakv6yjnmf5"></textarea>
        </div>
      </div>
    </div>;
}